import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import "./styles/variables.css";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/buttons.css";
import "./styles/common.css";
// import Home from "./pages/Home";
// import Services from "./pages/Services";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import Blog from "./pages/Blog";
// import Faq from "./pages/Faq";
import SpinningLogo from "./components/SpinningLogo";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import { HelmetProvider } from "react-helmet-async";
const Article = lazy(() => import("./pages/Article"));

const Home = lazy(() => import("./pages/Home"));
const Services = lazy(() => import("./pages/Services"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Blog = lazy(() => import("./pages/Blog"));
const Faq = lazy(() => import("./pages/Faq"));
const Referrals = lazy(() => import("./pages/Referrals"));
const Resources = lazy(() => import("./pages/Resources"));
const BookNow = lazy(() => import("./pages/BookNow"));


function App() {
  return (
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <div className="app-wrap">
            <Navbar />
            <Suspense fallback={<SpinningLogo />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/services" element={<Services />} />
                {/* <Route path="/blog" element={<Blog />} /> */}
                <Route path="/about-us" element={<About />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/faqs" element={<Faq />} />
                <Route path="/referrals" element={<Referrals />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/resources/:slug" element={<Article />} />
                <Route path="/book-now" element={<BookNow />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
            </Suspense>
            <Link to="/referrals" className="referral-float">
              Refer a Participant
            </Link>
          </div>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
}

export default App;
